import CustomTable from "../../../../../components/table/CustomTable";
import React from "react";
import AttendanceHead from "./AttendanceHead";
import {AttendancePeriodTableApp} from "../Functionality/AttendancePeriodTableApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendancePeriodTable = ({
    selectedOption,
    searchElement,
    search,
    option,
    setSimpleSearch,
    setSearch,
    finalArray,
    setSearchElement,
    setBodyForExport,
    searchClean,
    contractorId,
    supplierId,
    setSendSimpleSearch,
    setSelectedOption,
    view,
    setView,
    render,
    setRender,
    color,
    modified,
    setModified,
    handleView
}) => {

    const {
        attendanceStartDate,
        attendanceEndDate,
        rowsPerPage,
        tableId,
        thead,
        tbody,
        pagination,
        searchId,
        setResults,
        selectedDate,
        setSelectedDate,
        handleChange,
        getData
    } = AttendancePeriodTableApp({
        selectedOption,
        searchElement,
        option,
        setRender,
        color,
        setBodyForExport,
        modified,
        setModified
    });

    return (
        <>
            <AttendanceHead
                view={view}
                setView={setView}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                attendanceStartDate={attendanceStartDate}
                attendanceEndDate={attendanceEndDate}
                selectedOption={selectedOption}
                setSimpleSearch={setSimpleSearch}
                searchClean={searchClean}
                setSearch={setSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                search={search}
                setSendSimpleSearch={setSendSimpleSearch}
                finalArray={finalArray}
                setSelectedOption={setSelectedOption}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                handleView={handleView}
                handleChange={handleChange}
                getData={getData}
            />
            <div className={"col-12"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    textNotInformation={'no_information_attendance'}
                    withoutHeight={true}
                />   {render}
            </div>
            {pagination()}
        </>

    )

}
export default AttendancePeriodTable
